import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { Input } from "@ember/component";
import { action } from "@ember/object";
import { isEmpty } from "@ember/utils";
import DButton from "discourse/ui-kit/d-button";
import DModal from "discourse/ui-kit/d-modal";
import { i18n } from "discourse-i18n";
import { buildCategoryGroup, isPositiveInteger } from "../lib/category-groups";

export default class EditCategoryGroup extends Component {
  @tracked categoryGroupName = this.categoryGroup?.name;
  @tracked postLimit = this.categoryGroup?.post_limit;
  @tracked topicLimit = this.categoryGroup?.topic_limit;
  @tracked cooldown = this.categoryGroup?.cooldown;
  @tracked flash;

  get categoryGroup() {
    return this.args.model.categoryGroup;
  }

  get formValues() {
    return {
      name: (this.categoryGroupName || "").toLowerCase().trim(),
      topic_limit: parseInt(this.topicLimit, 10),
      post_limit: parseInt(this.postLimit, 10),
      cooldown: parseInt(this.cooldown, 10),
    };
  }

  get disabled() {
    const { name, topic_limit, post_limit, cooldown } = this.formValues;

    return (
      isEmpty(name) ||
      ![topic_limit, post_limit, cooldown].every(isPositiveInteger)
    );
  }

  @action
  save() {
    this.flash = null;

    if (this.disabled) {
      return;
    }

    const values = this.formValues;
    const isDuplicate = this.args.model.categoryGroups.some(
      (cg) => cg !== this.categoryGroup && cg.name === values.name
    );

    if (isDuplicate) {
      this.flash = i18n(
        "flexible_rate_limits.admin.error.duplicate_category_group_name"
      );
      return;
    }

    if (this.categoryGroup) {
      Object.assign(this.categoryGroup, values);
    } else {
      this.args.model.categoryGroups.push(buildCategoryGroup(values));
    }

    this.args.closeModal();
  }

  <template>
    <DModal
      @closeModal={{@closeModal}}
      @title={{i18n "flexible_rate_limits.admin.category_group"}}
      @flash={{this.flash}}
      @flashType="error"
      id="edit-category-group-modal"
    >
      <:body>
        <table class="flr-table-modal">
          <tbody>
            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.group_name"
                }}</td>
              <td><Input @type="text" @value={{this.categoryGroupName}} /></td>
            </tr>

            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.post_limit"
                }}</td>
              <td><Input @type="number" @value={{this.postLimit}} min="1" /></td>
            </tr>

            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.topic_limit"
                }}</td>
              <td><Input
                  @type="number"
                  @value={{this.topicLimit}}
                  min="1"
                /></td>
            </tr>

            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.cooldown"
                }}</td>
              <td><Input @type="number" @value={{this.cooldown}} min="1" /></td>
            </tr>
          </tbody>
        </table>
      </:body>

      <:footer>
        <DButton
          @action={{this.save}}
          @label="flexible_rate_limits.admin.save"
          @disabled={{this.disabled}}
          class="btn-large btn-primary"
        />
      </:footer>
    </DModal>
  </template>
}
